import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GameCardBase, GC_BASE_CSS } from '@/src/app/uygulamalar/hmi-pano/pano/game-card-base';

const DURUM_RENK: Record<string, string> = { 'Bekliyor': '#94a3b8', 'Devam Ediyor': '#6366f1', 'Tamamlandı': '#22c55e', 'İptal': '#ef4444' };
const DURUM_RGB: Record<string, string> = { 'Bekliyor': '148,163,184', 'Devam Ediyor': '99,102,241', 'Tamamlandı': '34,197,94', 'İptal': '239,68,68' };
const DURUM_YUZDE: Record<string, number> = { 'Bekliyor': 10, 'Devam Ediyor': 55, 'Tamamlandı': 100, 'İptal': 0 };

@Component({
  selector: 'proje-gorev-kart',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="gc gc--proje-gorev" [style.--accent]="durumRenk()" [style.--accent-rgb]="durumRgb()" (mousemove)="mouseMove($event)" (mouseleave)="mouseLeave()" [ngStyle]="kartStil">
      <div class="gc-canli-bg"></div><div class="gc-parlak-kenar"></div>
      <div class="gc-kose gc-kose--sol-ust"></div><div class="gc-kose gc-kose--sag-ust"></div><div class="gc-kose gc-kose--sol-alt"></div><div class="gc-kose gc-kose--sag-alt"></div>
      <div class="gc-kose-ic gc-kose-ic--sol-ust"></div><div class="gc-kose-ic gc-kose-ic--sag-ust"></div><div class="gc-kose-ic gc-kose-ic--sol-alt"></div><div class="gc-kose-ic gc-kose-ic--sag-alt"></div>
      <div class="gc-rarity-serit"></div><div class="gc-ic-glow"></div><div class="gc-desen"></div><div class="gc-shimmer"></div><div class="gc-holo"></div>
      <div class="gc-kenar-glow" [style.background]="kenarGlow"></div>
      <div class="gc-parcaciklar"><span class="gc-p gc-p--buyuk" style="--d:8s;--x:12%;--y:22%"></span><span class="gc-p" style="--d:11s;--x:78%;--y:38%"></span><span class="gc-p gc-p--kucuk" style="--d:6s;--x:55%;--y:68%"></span></div>
      <div class="gc-icerik">
        <div class="gc-hud-baslik">PROJE GÖREVİ</div>
        <div class="pg-ad gc-baslik-ana">{{ p()?.gorevAdi || 'Görev' }}</div>
        <div class="pg-detay">
          @if (p()?.atanan) { <span class="pg-atanan"><svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>{{ p().atanan }}</span> }
          @if (p()?.baslangic || p()?.bitis) { <span class="pg-tarih">{{ tarihAraligi() }}</span> }
        </div>
        <div class="pg-ilerleme">
          <span class="pg-durum" [style.color]="durumRenk()">{{ p()?.durum || 'Bekliyor' }}</span>
          <div class="gc-stat-bar"><div class="gc-stat-bar-dolgu" [style.width.%]="gorunur() ? durumYuzde() : 0" [style.background]="'linear-gradient(90deg, ' + durumRenk() + ', color-mix(in srgb, ' + durumRenk() + ' 60%, #fff))'"></div></div>
        </div>
        <div class="gc-xp-bar"><div class="gc-xp-dolgu" [style.width.%]="gorunur() ? durumYuzde() : 0"></div></div>
      </div>
    </div>
  `,
  styles: [GC_BASE_CSS, `
    .gc { --accent: #6366f1; --accent-rgb: 99,102,241; }
    .pg-ad { font-size: 13px; font-weight: 700; color: var(--py-metin, #e2e8f0); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    .pg-detay { display: flex; gap: 12px; align-items: center; flex-wrap: wrap; }
    .pg-atanan { display: flex; align-items: center; gap: 4px; font-size: 10px; color: var(--py-metin-ikincil, #64748b); }
    .pg-atanan svg { color: var(--accent); opacity: .5; }
    .pg-tarih { font-size: 9px; color: var(--py-metin-ikincil, #64748b); font-variant-numeric: tabular-nums; }
    .pg-ilerleme { display: flex; flex-direction: column; gap: 3px; }
    .pg-durum { font-size: 9px; font-weight: 700; letter-spacing: .06em; text-transform: uppercase; }
  `],
})
export class ProjeGorevKartComponent extends GameCardBase {
  parametreler = input<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
  durumRenk = computed(() => DURUM_RENK[this.p()?.durum] || '#94a3b8');
  durumRgb = computed(() => DURUM_RGB[this.p()?.durum] || '148,163,184');
  durumYuzde = computed(() => DURUM_YUZDE[this.p()?.durum] || 10);
  tarihAraligi = computed(() => {
    const fmt = (d: any) => d ? new Date(d).toLocaleDateString('tr-TR', { day: '2-digit', month: 'short' }) : '';
    const b = fmt(this.p()?.baslangic);
    const s = fmt(this.p()?.bitis);
    if (b && s) return b + ' → ' + s;
    return b || s || '';
  });
}
